/**
 * Return current Unix timestamp.
 *
 * @returns {number}
 */
export default function () {
  return Math.round((!Date.now) ? new Date().getTime() : Date.now() / 1000)
}
